/** Group marketing templates by pre-built funnel metadata from the API. */

export function groupTemplatesByFunnel(templates = []) {
  const funnels = new Map();
  const standalone = [];

  for (const template of templates) {
    if (template.funnel_slug) {
      if (!funnels.has(template.funnel_slug)) {
        funnels.set(template.funnel_slug, {
          slug: template.funnel_slug,
          name: template.funnel_name || template.funnel_slug,
          description: template.funnel_description || '',
          steps: [],
        });
      }
      funnels.get(template.funnel_slug).steps.push(template);
    } else {
      standalone.push(template);
    }
  }

  const funnelList = Array.from(funnels.values()).map((funnel) => ({
    ...funnel,
    steps: funnel.steps.sort((a, b) => (a.funnel_step || 0) - (b.funnel_step || 0)),
  }));

  funnelList.sort((a, b) => a.name.localeCompare(b.name));
  return { funnels: funnelList, standalone };
}
